import React, { useCallback } from 'react';
import { mapAudio } from '../helpers/AudioHelper';
import { useSelector } from '../store';
import { selectSecondaryRingerDeviceId } from '../store/reducers/devices';
import { selectCall } from '../store/reducers/janus';

export default function Ringer() {
  const call = useSelector(selectCall)
  const secondaryRingerDeviceId = useSelector(selectSecondaryRingerDeviceId)

  const setSyncId = useCallback((audio: HTMLAudioElement | null) => {
    if (!audio) { return }
    if (supportsSinkApi(audio)) {
      audio.setSinkId(secondaryRingerDeviceId)
    }
  }, [secondaryRingerDeviceId])

  return (
    <>
      {call.canAnswer ? <audio autoPlay loop src={mapAudio(require('./sounds/incoming-call.wav'))} /> : null}
      {call.canAnswer && secondaryRingerDeviceId ? <audio id='secondaryRinger' autoPlay loop src={mapAudio(require('./sounds/incoming-call.wav'))} ref={setSyncId} /> : null}
      {call.canRingOut ? <audio autoPlay loop src={mapAudio(require('./sounds/ringback-tone-nz.mp3'))} /> : null}
      {call.canPlayReorderTone ? <audio autoPlay loop src={mapAudio(require('./sounds/reorder-tone-nz.mp3'))} /> : null}
      {call.canPlayBusyTone ? <audio autoPlay loop src={mapAudio(require('./sounds/busy-tone-nz.mp3'))} /> : null}
      {call.canPlayNuTone ? <audio autoPlay loop src={mapAudio(require('./sounds/nu-tone-nz.mp3'))} /> : null}
    </>
  )
}

function supportsSinkApi(audio: HTMLAudioElement): audio is HTMLAudioElement & NewSinkApi {
  return 'setSinkId' in audio
}

type NewSinkApi = {
  setSinkId(id: string): void
}